import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectSignedIn, signOut } from "reducers/auth";
import Button from "components/ui/Button";
import { AccessElement, useLoadScopes } from "helpers/auth";
import { Link, WindowLocation, navigate } from "@reach/router";
import Logo_Light from "assets/Logo_Light.png";
import Mobile_02 from "assets/Icon_Mobile_02.png";
import BackArrow from "assets/Icon_Back.png";
import DashboardIcon from "assets/Icon_Menu_01.png";
import MeetingsIcon from "assets/Meetings_Icon.png";
import { NavLink } from "./NavLink";
import { AppPath } from "appConstants";
import { translations } from "translations";
import { useOnClickOutside } from "@avamae/hooks";
import AccountMenuDropdown from "components/PageComponents/accountMenuDropdown/AccountMenuDropdown";
import { selectIsNavBarShrunk } from "reducers/shrinkNavBar";
import useMedia from "use-media";

type Props = {
  mobileNavOpen: boolean;
  closeMobileNav(): void;
  location: WindowLocation;
  hide?: boolean;
};

type PublicNavItem = {
  path: AppPath;
  label: string;
  icon?: string;
};

const navItems: PublicNavItem[] = [
  {
    path: AppPath.DASHBOARD,
    label: translations.navigationBar.navItem_1,
    icon: DashboardIcon,
  },
  {
    path: AppPath.MEETINGS,
    label: translations.navigationBar.navItem_2,
    icon: MeetingsIcon,
  },
];

const Navigation: React.FC<Props> = ({
  closeMobileNav,
  location,
  mobileNavOpen,
  hide,
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const shrinkMenu = useSelector(selectIsNavBarShrunk);
  const bind = useOnClickOutside(() => {
    closeMobileNav();
  }, true);
  const isDesktop = useMedia("(min-width: 1200px)");

  const dispatch = useDispatch();
  const isSignedIn = useSelector(selectSignedIn);
  const accessElements = useLoadScopes();

  if (!isSignedIn || hide) return null;

  const pathname = location.pathname;

  return (
    <nav
      id="MainNavigation"
      className={mobileNavOpen ? "Navigation Open" : "Navigation"}
      {...bind}
    >
      <div className={`Inner ${shrinkMenu && isDesktop ? "Shrunk" : ""}`}>
        <div className="Block">
          <div className="Links">
            {navItems &&
              navItems.map((item: PublicNavItem, idx) => {
                return (
                  <NavLink
                    key={idx}
                    path={item.path}
                    closeBurgerMenu={() => {
                      closeMobileNav();
                    }}
                    icon={item.icon}
                  >
                    {item.label}
                  </NavLink>
                );
              })}
          </div>
          <div className="AdditionalLinks">
            {mobileNavOpen ? <AccountMenuDropdown /> : ""}
          </div>
          {/* <div className="Logo">
            <img src={Logo_Light} alt="Logo" onClick={() => navigate("/")} />
          </div>
          <ul>
            {accessElements
              .sort((a, b) => a.displayName.localeCompare(b.displayName))
              .map(e => (
                <TopLevelItem
                  key={e.displayName}
                  accessElement={e}
                  active={pathname.includes(e.path)}
                  closeMobileNav={closeMobileNav}
                />
              ))}
          </ul> */}
          <div className="BottomNav"></div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;

const TopLevelItem: React.FC<{
  accessElement: AccessElement;
  active: boolean;
  closeMobileNav(): void;
}> = ({ accessElement, active, closeMobileNav }) => {
  return (
    <li className={active ? "Active" : ""}>
      <Link to={accessElement.path} onClick={closeMobileNav}>
        {accessElement.displayName}
      </Link>
    </li>
  );
};
